import Component_FromInstance_df569a47653551c1398a33c99a0de22c from "../../../../content/examples/basic/from-instance/FromInstance";
import Devtool_FromInstance_df569a47653551c1398a33c99a0de22c from "!!@devtool/loader!../../../../content/examples/basic/from-instance/FromInstance";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_FromInstance_df569a47653551c1398a33c99a0de22c,
  Devtool_FromInstance_df569a47653551c1398a33c99a0de22c,
  DevTool,
  React
};